import { render, staticRenderFns } from "./DialogTheFork.vue?vue&type=template&id=1efe4cc2"
import script from "./DialogTheFork.vue?vue&type=script&lang=js"
export * from "./DialogTheFork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports